module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO ORIGINAL-259ca52d9250183d02bbe9287c48c629.png";